<template>
  <div>
    <ModalWithTabs
      name="tipoTicketEdit"
      :tabs="tabsConfig"
      @before-open="onModalOpen"
      @closed="onModalClosed"
    >
      <template #0>
        <div class="xrow">
          <div class="col-1-3">
            <div class="form-group">
              <label>
                <span>Chave</span>
                <ShowHint hint="hintChave" />
              </label>
              <input class="form-control" v-model="item.chave" />
              <div class="message">
                {{ validation.firstError("item.chave") }}
              </div>
            </div>
          </div>
          <div class="col-1-3">
            <div class="form-group">
              <label>Descrição</label>
              <input class="form-control" v-model="item.desc" />
              <div class="message">
                {{ validation.firstError("item.desc") }}
              </div>
            </div>
          </div>
          <div class="col-1-3">
            <div class="form-group">
              <label>Menu</label>
              <select class="form-control" v-model="item.menu">
                <option
                  v-for="(desc, key) in tipoTicketMenu"
                  :value="key"
                  :key="key"
                >
                  {{ desc }}
                </option>
              </select>
              <div class="message">
                {{ validation.firstError("item.menu") }}
              </div>
            </div>
          </div>
        </div>
        <div class="xrow">
          <div
            class="col-1-3"
            v-for="campo in [
              'usa_nota',
              'usa_produto',
              'usa_nota_produto',
            ]"
            :key="campo"
          >
            <div class="form-group">
              <label>{{ getLabel(campo) }}</label>
              <select class="form-control" v-model="item[campo]">
                <option
                  v-for="(desc, key) in tipoTicketConfiguracao"
                  :value="key"
                  :key="key"
                >
                  {{ desc }}
                </option>
              </select>
              <div class="message">
                {{ validation.firstError("item." + campo) }}
              </div>
            </div>
          </div>
        </div>
        <div class="xrow">
          <div class="col-1-3">
            <div class="form-group">
              <label>Gera espelho devolução</label>
              <select
                class="form-control"
                v-model="item.gera_espelho_devolucao"
              >
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </select>
              <div class="message">
                {{ validation.firstError("item.gera_espelho_devolucao") }}
              </div>
            </div>
          </div>
          <div
            class="col-1-3"
            v-for="campo in ['usa_consumidor_final', 'usa_mensagem']"
            :key="campo"
          >
            <div class="form-group">
              <label>{{ getLabel(campo) }}</label>
              <select class="form-control" v-model="item[campo]">
                <option
                  v-for="(desc, key) in tipoTicketConfiguracao"
                  :value="key"
                  :key="key"
                >
                  {{ desc }}
                </option>
              </select>
              <div class="message">
                {{ validation.firstError("item." + campo) }}
              </div>
            </div>
          </div>
        </div>
        <div class="xrow">
          <div
            class="col-1-3"
            v-for="campo in [
              'usa_prorrogacao',
              'usa_assunto',
              'usa_transportadora',
            ]"
            :key="campo"
          >
            <div class="form-group">
              <label>{{ getLabel(campo) }}</label>
              <select class="form-control" v-model="item[campo]">
                <option
                  v-for="(desc, key) in tipoTicketConfiguracao"
                  :value="key"
                  :key="key"
                >
                  {{ desc }}
                </option>
              </select>
              <div class="message">
                {{ validation.firstError("item." + campo) }}
              </div>
            </div>
          </div>
        </div>
        <div class="xrow">
          <div class="col-1-3">
            <div class="form-group">
              <label>{{ getDescricaoAcessoSistema("acessab2b") }}</label>
              <select class="form-control" v-model="item.acessab2b">
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </select>
              <div class="message">
                {{ validation.firstError("item.acessab2b") }}
              </div>
            </div>
          </div>
          <div class="col-1-3">
            <div class="form-group">
              <label>{{
                getDescricaoAcessoSistema("acessacallcenter")
              }}</label>
              <select
                class="form-control"
                v-model="item.acessacallcenter"
              >
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </select>
              <div class="message">
                {{ validation.firstError("item.acessacallcenter") }}
              </div>
            </div>
          </div>
          <div class="col-1-3">
            <div class="form-group">
              <label>{{ getDescricaoAcessoSistema("acessafv") }}</label>
              <select class="form-control" v-model="item.acessafv">
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </select>
              <div class="message">
                {{ validation.firstError("item.acessafv") }}
              </div>
            </div>
          </div>
        </div>
        <div class="xrow edit-buttons">
          <button
            :class="{
              'button button-success': true,
              'button-disabled': validation.hasError(),
            }"
            @click="handleSubmit"
          >
            Salvar
          </button>
          &nbsp;
          <button class="button" @click="close">Fechar</button>
        </div>
      </template>

      <template #1>
        <VincularCamposAdicionais
          ref="vincularCampos"
          :item-id="vincularItemId"
          :endpoint="`/admin/sac/tipo-ticket/${item.id}/campos-adicionais`"
          :sistemasDisponiveis="sistemasDisponiveis"
          @saved="close"
        />
      </template>
    </ModalWithTabs>
  </div>
</template>

<script>
import SimpleVueValidation from "simple-vue-validator";
import ShowHint from "@/components/ShowHint.vue";
import VincularCamposAdicionais from "../VincularCamposAdicionais.vue";
import ModalWithTabs from "../../../../components/ModalWithTabs.vue";

const Validator = SimpleVueValidation.Validator.create({
  templates: {
    required: "*obrigatório",
  },
});

export default {
  name: "tipoTicketEdit",
  props: [
    "item",
    "update",
    "close",
    "doRequest",
    "descSingular",
    "tipoTicketMenu",
    "tipoTicketConfiguracao",
    "getDescricaoAcessoSistema",
  ],
  components: { ShowHint, VincularCamposAdicionais, ModalWithTabs },
  data() {
    return {
      vincularItemId: null,
      itemSnapshot: null,
    };
  },
  computed: {
    sistemasDisponiveis() {
      const sistemas = [{ chave: "SAC", label: "SAC" }];
      if (parseInt(this.item.acessab2b))
        sistemas.push({ chave: "B2B", label: "B2B" });
      if (parseInt(this.item.acessacallcenter))
        sistemas.push({ chave: "CALLCENTER", label: "Callcenter" });
      if (parseInt(this.item.acessafv))
        sistemas.push({ chave: "FORCA_VENDAS", label: "Força de Vendas" });
      return sistemas;
    },
    tabsConfig() {
      return [
        {
          title: this.getTitleModal(this.item) + this.descSingular,
          isDirty: () => this.formIsDirty(),
          onSave: () => this.handleSaveForTabChange(),
          onDiscard: () => this.discardFormChanges(),
        },
        {
          title: "Vincular Campos Adicionais",
          disabled: !this.item.id,
          isDirty: () => this.$refs.vincularCampos?.isDirty() ?? false,
          onSave: () => this.$refs.vincularCampos?.save(),
          onDiscard: () => this.$refs.vincularCampos?.discard(),
        },
      ];
    },
  },
  validators: {
    "item.chave": (value) => Validator.value(value).required(),
    "item.desc": (value) => Validator.value(value).required(),
    "item.menu": (value) => Validator.value(value).required(),
    "item.usa_transportadora": (value) => Validator.value(value).required(),
    "item.usa_produto": (value) => Validator.value(value).required(),
    "item.destaca": (value) => Validator.value(value).required(),
    "item.usa_consumidor_final": (value) => Validator.value(value).required(),
    "item.usa_mensagem": (value) => Validator.value(value).required(),
    "item.usa_nota": (value) => Validator.value(value).required(),
    "item.usa_nota_produto": (value) => Validator.value(value).required(),
    "item.usa_prorrogacao": (value) => Validator.value(value).required(),
    "item.gera_espelho_devolucao": (value) => Validator.value(value).required(),
    "item.acessab2b": (value) => Validator.value(value).required(),
    "item.acessacallcenter": (value) => Validator.value(value).required(),
    "item.acessafv": (value) => Validator.value(value).required(),
  },
  methods: {
    onModalOpen() {
      this.$nextTick(() => {
        this.vincularItemId = this.item.id || null;
        this.itemSnapshot = JSON.parse(JSON.stringify(this.item));
      });
    },
    onModalClosed() {
      this.vincularItemId = null;
      this.itemSnapshot = null;
    },
    formIsDirty() {
      if (!this.itemSnapshot) return false;
      return JSON.stringify(this.item) !== JSON.stringify(this.itemSnapshot);
    },
    discardFormChanges() {
      if (this.itemSnapshot) Object.assign(this.item, this.itemSnapshot);
    },
    async handleSaveForTabChange() {
      const valid = await this.$validate();
      if (!valid) throw new Error("Preencha os campos obrigatórios.");
      await this.doRequest();
      this.itemSnapshot = JSON.parse(JSON.stringify(this.item));
      this.$refs.vincularCampos?.syncSistemas();
      this.$emit('saved');
      return true;
    },
    handleSubmit() {
      this.$validate().then((success) => {
        if (success) {
          this.update();
        }
      });
    },
    getTitleModal(item) {
      if (item.id) {
        return "Editando ";
      }
      return "Criando ";
    },
    getLabel(campo) {
      const labels = {
        usa_nota: "Usa nota",
        usa_produto: "Usa produto",
        usa_nota_produto: "Usa nota produto",
        usa_consumidor_final: "Usa consumidor final",
        usa_mensagem: "Usa mensagem",
        usa_prorrogacao: "Usa prorrogação",
        usa_assunto: "Usa assunto",
        usa_transportadora: "Usa transportadora",
      };
      return labels[campo] || campo;
    },
  },
};
</script>

<style scoped>
</style>
